import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import { contractStatus, contractType } from '../../../common/enums';
import { selectToken } from '../../../features/auth/ducks';
import { showModal } from '../../../features/modal/ducks';
import { signInfoObligationsActions } from '../ducks';
import { apiCallIds } from '../api';
import { getFileUrl } from '../../../common/utils/helpers';
import { selectIsInProgress } from '../../../features/spinner/ducks';

const SIGNING_PHASE_SIGN = 'sign';
const SIGNING_PHASE_CONFIRM = 'confirm';

const mapStateToProps = state => ({
  token: selectToken(state),
  isSignLoading: selectIsInProgress(state, apiCallIds.SIGN_INFO_OBLIGATIONS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signInfoObligations: signInfoObligationsActions.request,
      showConfirmInfoObligationsModal: loanId => showModal({
        id: apiCallIds.CONFIRM_INFO_OBLIGATIONS,
        data: loanId,
      }),
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class SignInfoObligationsBlock extends Component {
  static propTypes = {
    loan: PropTypes.object.isRequired,
    initialPhase: PropTypes.string,
    token: PropTypes.string.isRequired,
    isSignLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    phase: this.props.initialPhase || SIGNING_PHASE_SIGN,
    signError: null,
  };

  getInfoContract() {
    const { loan } = this.props;
    // When the IPK is PENDING_CONFIRMATION it is no longer exposed in loan.contracts
    // (unsigned docs must not appear in document surfaces). The DTO exposes the pending
    // document reference via loan.infoObligationsPending so the signing PDF link remains
    // accessible during the signing flow.
    if (loan.infoObligationsPending) {
      return {
        type: contractType.INFORMATION_OBLIGATIONS_DEBTOR,
        fileId: loan.infoObligationsPending.fileId,
        id: loan.infoObligationsPending.contractId,
        status: loan.infoObligationsPending.status || contractStatus.INACTIVE,
      };
    }
    return loan.contracts
      ? loan.contracts.find(c => c.type === contractType.INFORMATION_OBLIGATIONS_DEBTOR)
      : null;
  }

  renderDocumentLink() {
    const { token, t } = this.props;
    const infoContract = this.getInfoContract();
    const fileLocation = infoContract && infoContract.fileId ? getFileUrl(infoContract.fileId, token) : null;

    if (!fileLocation) {
      return null;
    }

    return (
      <a className="info-obligations-read-link" href={fileLocation} target="_blank" rel="noopener noreferrer">
        {t('Prečítať dokument Informačné povinnosti poskytovateľa služieb')}
      </a>
    );
  }

  handleSign = () => {
    const { actions, loan } = this.props;
    actions.signInfoObligations({
      loanId: loan.id,
      onSuccess: () => this.setState({ phase: SIGNING_PHASE_CONFIRM, signError: null }),
      onError: (error) => this.setState({ signError: error || true }),
    });
  };

  showConfirmModal = () => {
    const { actions, loan } = this.props;
    actions.showConfirmInfoObligationsModal(loan.id);
  };

  renderSignPhase() {
    const { isSignLoading, t } = this.props;
    const { signError } = this.state;

    const explanatoryText = t(
      'Pred podpisom žiadosti je potrebné podpísať Informačné povinnosti poskytovateľa služieb. ' +
      'Po kliknutí na tlačidlo "Podpísať" vám bude zaslaný SMS kód na potvrdenie podpisu.'
    );

    return (
      <div>
        <p>{explanatoryText}</p>
        {signError && (
          <p style={{ color: 'red' }}>
            {typeof signError === 'string' ? signError : t('Podpis sa nepodaril. Skúste znova.')}
          </p>
        )}
        <div className="ant-modal-footer info-obligations-actions">
          {this.renderDocumentLink()}
          <Button
            size="small"
            type="primary"
            loading={isSignLoading}
            onClick={this.handleSign}
          >
            {t('Podpísať Informačné povinnosti')}
          </Button>
        </div>
      </div>
    );
  }

  renderConfirmPhase() {
    const { t } = this.props;

    return (
      <div>
        <p>{t('SMS kód bol odoslaný. Zadajte ho v modálnom okne pre potvrdenie Informačných povinností klienta.')}</p>
        <div className="ant-modal-footer info-obligations-actions">
          {this.renderDocumentLink()}
          <Button
            size="small"
            type="primary"
            onClick={this.showConfirmModal}
          >
            {t('Zadať SMS kód')}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { phase } = this.state;

    if (phase === SIGNING_PHASE_CONFIRM) {
      return this.renderConfirmPhase();
    }
    return this.renderSignPhase();
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/SignInfoObligationsBlock.js